import React from 'react';
import SellersContainer from '../containers/sellers_container';

const SellersContext = React.createContext(new SellersContainer());

export default SellersContext;
